import React from 'react';
import { Button } from "@mui/material";
import CallIcon from '../images/CallIcon.svg';
import TextSmall from './TextSmall';

const CallCenter = () => {

  // Detect if the user is in a browser environment
  const isBrowser = typeof window !== "undefined";

  // Detect if the user is on mobile
  // const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const isMobile = isBrowser ? /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) : false;

  // Function to handle WhatsApp click
  const handleWhatsAppClick = () => {
    const phoneNumber = '0765884881'; // Client's phone number
    const whatsappUrl = isMobile
      ? `https://api.whatsapp.com/send?phone=94${phoneNumber}`  // Mobile link
      : `https://web.whatsapp.com/send?phone=94${phoneNumber}`; // Desktop link

    window.open(whatsappUrl, '_blank');  // Open in a new tab
  };

  return (
    isMobile ? (
      <Button
        className="call-center-button"
        sx={{
          '&.MuiButton-root': {
            backgroundColor: '#000000',
            color: '#FFFFFF',
            textTransform: 'none',
            borderRadius: '50px',
            // paddingLeft: '1.5rem',
            paddingRight: '5px',
            position: 'fixed',
            bottom: '3%',
            right: '1%',
            zIndex: 999
          }
        }}
        onClick={handleWhatsAppClick}  // Handle click
      >
        <img src={CallIcon} alt="CallIcon" />
      </Button>
    ) : (
      <Button
        className="call-center-button"
        sx={{
          '&.MuiButton-root': {
            backgroundColor: '#000000',
            color: '#FFFFFF',
            textTransform: 'none',
            borderRadius: '50px',
            paddingLeft: '1.5rem',
            paddingRight: '5px',
            position: 'fixed',
            bottom: '3%',
            right: '1%',
            zIndex: 999
          }
        }}
        onClick={handleWhatsAppClick}  // Handle click
      >
        <TextSmall content="Happy Life Center" color="#FFFFFF" />
        <img src={CallIcon} alt="CallIcon" style={{ marginLeft: '0.8rem' }} />
      </Button>
    )
  );
}

export default CallCenter;
